
import {
    COACHINGDASHBOARD_LOAD,
    COACHINGDASHBOARD_UNLOAD,
    COACHINGDASHBOARD_SET,
} from '../../../actionDefinitions';

import {
    fetchCoachedAgentsData,
    fetchCoachingSummaryStats
} from '../../../api/v3/CoachingApi';

import {
    fetchCalibratedOnSurveyQuestions,
} from '../../../api/v3/DataApi';

export function loadCoachingDashboardScreen(fromDate, toDate) {
    return dispatch => {
        dispatch(loadCoachedAgentsData(fromDate, toDate));
        dispatch(loadCoachingSummaryStats(fromDate, toDate));        
        dispatch(loadCalibratedOnSurveyQuestions());
    };
}

export function loadCoachedAgentsData(fromDate, toDate) {
    return dispatch =>
        fetchCoachedAgentsData(fromDate, toDate)
            .then(payload => dispatch({ type: COACHINGDASHBOARD_LOAD, payload: { coachedAgentsData: payload.result } }))
            .catch(payload => dispatch({ type: COACHINGDASHBOARD_LOAD, error: true, payload }))
}

export function loadCoachingSummaryStats(fromDate, toDate) {
    return dispatch =>
        fetchCoachingSummaryStats(fromDate, toDate)
            .then(payload => dispatch({ type: COACHINGDASHBOARD_LOAD, payload: { coachingSummary: payload.result } }))
            .catch(payload => dispatch({ type: COACHINGDASHBOARD_LOAD, error: true, payload }))
}

export function loadCalibratedOnSurveyQuestions() {
    return dispatch =>
        fetchCalibratedOnSurveyQuestions()
            .then(payload => dispatch({ type: COACHINGDASHBOARD_LOAD, payload: { calibratedOnSurveyQuestions: payload.result } }))
            .catch(payload => dispatch({ type: COACHINGDASHBOARD_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: COACHINGDASHBOARD_SET, updatedProps });
    }
}
